import { Record as record } from 'immutable';

import { construct, resolve, resolveAll } from '../../helpers/LinkMapper';

import Order from '../Order';
import { APIPager } from '../../helpers/Pager';

export default class CustomerOrdersList extends record({ pagination: null, orders: null}) {

    static fromJSON (json = {}) {
        return construct(CustomerOrdersList, json, {
            pagination: resolve.as(APIPager),
            orders: resolveAll.as(Order)
        });
    }

}
